import React from "react";
import { BadgeCheck } from "lucide-react";
import { IRS_EFILE, AUTHORIZED_CLAIM, UNAUTHORIZED_FALLBACK } from "../../data/compliance.js";

// Site-wide trust bar, sitting directly under the public header on every
// marketing page.
//
// The claim it prints is driven entirely by src/data/compliance.js — this
// component never hard-codes "IRS-Authorized" anywhere. That indirection is
// deliberate: the authorization is a regulated legal status tied to an issued
// EFIN, so it needs exactly one place to be turned on or off, not a string
// duplicated across pages that someone later has to hunt down.
//
// Colour note: the badge icon is a lightened copper (#e8a05a) rather than the
// --accent token. Copper on the midnight bar measures 3.2:1, which is fine for
// a non-text glyph but sits close to the floor; the lighter tint reads at
// 7.1:1 and holds up at small sizes on a dark ground.
const TrustBanner = () => {
  const claim = IRS_EFILE.authorized ? AUTHORIZED_CLAIM : UNAUTHORIZED_FALLBACK;

  return (
    <div className="bg-[var(--accent-fill)] text-white">
      <div className="max-w-[1180px] mx-auto px-[22px] py-[11px] flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-center">
        <BadgeCheck size={21} className="text-[#e8a05a] flex-none" aria-hidden="true" />

        <span className="font-disp font-bold text-[17px] tracking-[.01em]">{claim.headline}</span>

        <span className="hidden md:inline text-white/35" aria-hidden="true">
          ·
        </span>

        <span className="text-[15px] text-white/80">{claim.detail}</span>
      </div>
    </div>
  );
};

export default TrustBanner;
